export const headCells= [
                    {
                      id: "name",
                      numeric: true,
                      disablePadding: false,
                      label: "Name",
                    },
                    {
                      id: "phone_number",
                      numeric: true,
                      disablePadding: false,
                      label: "Phone number",
                    },
                    {
                      id: "notifications",
                      numeric: true,
                      disablePadding: false,
                      label: "Notifications",
                    },
                    {
                      id: "from_date",
                      numeric: true,
                      disablePadding: false,
                      label: "From date",
                    },
                    {
                      id: "to_date",
                      numeric: true,
                      disablePadding: false,
                      label: "To date",
                    },
                    {
                      id: "action",
                      numeric: true,
                      disablePadding: false,
                      label: "Action",
                    },
                  ];